import { defineStore } from "pinia";
import axiosInstance from "@/utils/http.js";
import { useSettingsStore } from ".";
const axios = axiosInstance;
import * as utils from "@/utils/utils.js"

export const CLEARFXAI_API_URL = "https://go.clearfxai.com"

export const DEVSAFRA_API_URL = process.env.VUE_APP_DEVSAFRA_API_URL;
export const APIKEY = process.env.VUE_APP_APIKEY;
export const SECRETKEY = process.env.VUE_APP_SECRETKEY;

export const API_PATH = `apiv1.3/cfxai`
export const API_PATH_REST = `v1/clearfxai/`

export let MARKET_PATH = `${API_PATH}/fxmarket/${API_PATH_REST}`

export const useFxMarketStore = defineStore("fxMarket", {
  state: () => ({
    fxMarketIntradayData: undefined, // from AlphaVantage
    fxMarketNews: [], // from AlphaVantage
    fxMarketAvgPtax: undefined, // from Banco Central
    fxMarketDailyData: undefined, // from AlphaVantage
    fxMarketEconomicCalendar: [], // from TradingView,
  }),
  getters: {
    getFxMarketIntradayData: (state) => state.fxMarketIntradayData,
    getFxMarketNews: (state) => state.fxMarketNews,
    getFxMarketAvgPtax: (state) => state.fxMarketAvgPtax,
    getFxMarketDailyData: (state) => state.fxMarketDailyData,
    getFxMarketEconomicCalendar: (state) => state.fxMarketEconomicCalendar,
  },
  actions: {
    // broker marketdada
    getBrokerMarketdata(currencyPairs) {
      const params = currencyPairs
        .map((pair) => `${pair.fromCcy}-${pair.toCcy}`)
        .join(",");
      const url = `${CLEARFXAI_API_URL}/${MARKET_PATH}/broker-marketdata`;
      return axios.get(url, {
        params: {
          pairs: params,
        },
      });
    },
    // fxMarketCrossQuotes
    getFxMarketDataQuarterMinute(currencyPairs) {
      const params = currencyPairs
        .map((pair) => `${pair.fromCcy}-${pair.toCcy}`)
        .join(",");
      const url = `${CLEARFXAI_API_URL}/${MARKET_PATH}/fx-market-data-quarter-minute`;
      return axios.get(url, {
        params: {
          pairs: params,
        },
      });
    },
    getYesterdayTimeZone() {
      const d = new Date();
      d.setDate(d.getDate() - 1);

      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");

      return `${yyyy}${mm}${dd}T0000`;
    },
    // fxMarketIntradayData and fxMarketNews
    getFxMarketDataMinutely(time_from) {
      const url = `${CLEARFXAI_API_URL}/${MARKET_PATH}/fx-market-data-minutely`;
      return axios.get(url, {
        params: {
          time_from: time_from,
        },
      });
    },
    // fxMarketAvgPtax, fxMarketDailyData and fxMarketEconomicCalendar
    getFxMarketDataHourly(from_date, to_date, countries, date_ptax) {
      const url = `${CLEARFXAI_API_URL}/${MARKET_PATH}/fx-market-data-hourly`;

      return axios.get(url, {
        params: { from_date, to_date, countries, date_ptax },
      });
    },
    getFxMarketQuote(ticker) {
      const url = `${CLEARFXAI_API_URL}/${MARKET_PATH}/quote`;

      return axios.get(url, {
        params: { ticker },
      });
    },
    getDollarRadar() {
      const url = `${CLEARFXAI_API_URL}/${MARKET_PATH}/dollar-radar`;
      return axios.get(url);
    },
    getHolidaysList() {
      const url = `${CLEARFXAI_API_URL}/${SANDBOX_PATH}/get-holidays-list`;
      return axios
        .get(url)
        .then((response) => {
          if (response.status === 200 && response.data) {
            return response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchFxMarketDataHourly(date_ptax = utils.getOffsetDate(0, true)) {
      const from_date = utils.getOffsetDate(0);
      const to_date = utils.getOffsetDate(10);
      const countries = "US,EU,BR";

      this.getFxMarketDataHourly(from_date, to_date, countries, date_ptax)
        .then((response) => {
          const { data, errors } = response.data;

          if (errors && Object.keys(errors).length > 0) {
            console.log(errors);
          }

          const events = data["fx-market-economic-calendar"]?.result || [];
          const fxMarketDailyList = data["fx-market-daily-data"] || null;
          let avgPtax = data["fx-market-avg-ptax"] || null;

          this.fxMarketEconomicCalendar = events;
          this.fxMarketDailyData = fxMarketDailyList;

          localStorage.setItem(
            "fxMarketEconomicCalendar",
            JSON.stringify(events),
          );
          localStorage.setItem(
            "fxMarketDailyData",
            JSON.stringify(fxMarketDailyList),
          );

          if (avgPtax?.error) {
            const fallbackDate = utils.getOffsetDate(-1, true);
            return this.fetchFxMarketDataHourly(fallbackDate);
          }

          this.fxMarketAvgPtax = avgPtax;
          localStorage.setItem("avgPtax", JSON.stringify(avgPtax));
          localStorage.setItem("lastFetchHourlyTime", new Date().toISOString());

          this.hasFetchedHourlySuccess = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchFxMarketDataMinutely() {
      // const topics = "economy_monetary,financial_markets,economy_macro,finance"
      const time_from = this.getYesterdayTimeZone();

      this.getFxMarketDataMinutely(time_from)
        .then((response) => {
          const data = response.data;
          const fxMarketNews = data["fx-market-news"];
          const fxMarketIntradayList = data["fx-market-intraday-data"];
          this.fxMarketNews = fxMarketNews;
          this.fxMarketIntradayData = fxMarketIntradayList;
          localStorage.setItem("fxMarketNews", JSON.stringify(fxMarketNews));
          localStorage.setItem(
            "fxMarketIntradayData",
            JSON.stringify(fxMarketIntradayList),
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkLastFetchHourlyAndUpdate() {
      const lastFetchHourlyTime = localStorage.getItem("lastFetchHourlyTime");
      const now = new Date();

      if (lastFetchHourlyTime) {
        const lastFetchDate = new Date(lastFetchHourlyTime);
        const timeDifference = (now - lastFetchDate) / (1000 * 60);

        if (timeDifference > 60) {
          this.fetchFxMarketDataHourly();
          return;
        }
      } else {
        this.fetchFxMarketDataHourly();
      }
      this.fxMarketEconomicCalendar = JSON.parse(
        localStorage.getItem("fxMarketEconomicCalendar"),
      );
      this.fxMarketAvgPtax = JSON.parse(localStorage.getItem("avgPtax"));
      this.fxMarketDailyData = JSON.parse(
        localStorage.getItem("fxMarketDailyData"),
      );
    },
    fetchMinutelyAndUpdate() {
      this.fetchFxMarketDataMinutely();
      this.intervalMinutely = setInterval(() => {
        this.fetchFxMarketDataMinutely();
      }, 60000);
      this.fxMarketNews = JSON.parse(localStorage.getItem("fxMarketNews"));
      this.fxMarketIntradayData = JSON.parse(
        localStorage.getItem("fxMarketIntradayData"),
      );
    },
  },
});
